export default "__VITE_PUBLIC_ASSET__56be6b02__"